import React from 'react';
import PropTypes from 'prop-types';
import memoizeOne from 'memoize-one';
import moment from 'moment';
import OverviewTable from '../../../components/Table/OverviewTable';
import { connections } from '../connections';

const columnDefinition = [
  { id: 'ticketDescription', label: 'Billet Typ' },
  { id: 'issuedTo', label: 'Ausgestellt auf' },
  { id: 'dateOfBirth', label: 'Geburtsdatum' },
  { id: 'price', label: 'Preis (CHF)' },
];

const transform = memoizeOne(tickets =>
  tickets.map(ticket => ({
    id: ticket.id,
    issuedTo: `${ticket.firstName} ${ticket.lastName}`,
    dateOfBirth: moment(ticket.dateOfBirth).format('D.M.YYYY'),
    ticketDescription: `${
      ticket.tripType === 'DAY_PASS'
        ? 'Tageskarte'
        : `${connections[ticket.route.origin].de} - ${
            connections[ticket.route.destination].de
          }`
    } ${ticket.halffare ? '1/2 - ' : '(Halbtax / '}${
      ticket.classType === 'FIRST_CLASS' ? '1.Kl)' : '2.Kl)'
    }`,
    price: (ticket.price / 100).toFixed(2),
  }))
);

export default function BlsTicketTable({ tickets }) {
  return (
    <OverviewTable
      columnDefinition={columnDefinition}
      data={transform(tickets)}
      hover={false}
    />
  );
}

BlsTicketTable.propTypes = {
  tickets: PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/views/bls/components/BlsTicketTable.jsx